import './styles.css'

import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/entry.nostyle'
import isAfter from 'date-fns/isAfter'
import { useMemo } from 'react'

import { Notify } from '../../lib/helpers'
import { ArrowDown } from './icons'

interface DatePickerProps {
    value: {
        selection: {
            startDate: Date
            endDate: Date
        }
    }
    onChange: (date: Date[]) => void
}
export function DatePicker({ value, onChange }: DatePickerProps) {
    const handleUpdate = (value: any) => {
        if (!isAfter(value[0], value[1])) {
            onChange(value)
        } else {
            Notify(
                'warning',
                'Invalid date range',
                'Please make sure that dates are in correct order',
            )
        }
    }

    const handleValue = useMemo(() => {
        return value
    }, [value])

    return (
        <DateRangePicker
            onChange={handleUpdate}
            value={handleValue}
            className='px-4 py-0 bg-white border-0 rounded-full shadow-lg'
            calendarIcon={<ArrowDown />}
            clearIcon={null}
            format='MMM dd, yyyy'
            calendarClassName='shadow-lg border-0 p-4 rounded-lg'
            maxDate={new Date()}
        />
    )
}
